exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen{[id*=ticket][data-v-b14ce14a]{display:none}}", ""]);

// exports
